import { createFileRoute } from "@tanstack/react-router";
import { DirectExpenseForm } from "@/components/DirectExpenseForm";

export const Route = createFileRoute("/_auth/direct-expense/new")({
  component: DirectExpenseForm,
});
